import { lightBlue } from "@mui/material/colors";
import { styled } from "@mui/material/styles";

const ProposalRedlineSubtext = styled("span", {
  shouldForwardProp: (prop) => !["added", "removed"].includes(prop.toString()),
})<{ added: boolean; removed: boolean }>(({ added, removed, theme }) => ({
  color: added ? theme.palette.info.main : removed ? theme.palette.text.secondary : "inherit",
  textDecoration: removed ? "line-through" : "none",
  textDecorationColor: removed ? lightBlue[700] : "currentcolor",
  textDecorationThickness: removed ? "2px" : "auto",
}));

export default ProposalRedlineSubtext;
